// extracted by mini-css-extract-plugin
module.exports = {"Container":"Signup_Container__A20Ip","Error":"Signup_Error__FzOZ3"};